import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { createClient } from "contentful";
import { BLOCKS } from "@contentful/rich-text-types";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const useBlogPosts = (params) => {
  const [pageLoading, setPageLoading] = useState(true);
  const [blogPosts, setBlogPosts] = useState([]);
  const client = createClient({
    space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
    accessToken: process.env.REACT_APP_CONTENTFUL_API_KEY,
  });

  useEffect(() => {
    fetchBlogPosts();
    // eslint-disable-next-line
  }, []);

  const options = {
    renderNode: {
      [BLOCKS.EMBEDDED_ASSET]: (node) => {
        const { title, file } = node.data.target.fields;

        return (
          <img
            src={`https:${file.url}`}
            alt={title}
            style={{
              maxWidth: "100%",
              height: "auto",
            }}
          />
        );
      },
    },
  };

  const fetchBlogPosts = async () => {
    try {
      const { items } = await client.getEntries({
        content_type: "mangroveBlogs",
        order: "sys.createdAt",
      });
      const posts = items.map((item, el) => {
        const { fields, sys } = item;
        return {
          author: fields.blogAuthor,
          title: fields.blogTitle,
          time: fields.timeToRead,
          category: fields.blogCategory,
          blogImage: fields.blogImage.fields.file.url,
          shortDescription: fields.shortDescription,
          blogDetails: documentToReactComponents(fields.blogDetails, options),
          createdAt: sys.createdAt,
          id: sys.id,
          isFeatured: !el,
        };
      });
      setBlogPosts(posts);
    } catch (error) {
      toast.error("There was a problem fetching blog posts");
    } finally {
      setPageLoading(false);
    }
  };

  return {
    blogPosts,
    filteredBlogPost:
      params && params?.postId
        ? blogPosts.find((post) => post.id === params.postId)
        : {},
    pageLoading,
  };
};

export default useBlogPosts;
